// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__c5Fvc","containerItemsCenter":"Skeleton_containerItemsCenter__1G2YF"};